import { render, staticRenderFns } from "./CommonPage.vue?vue&type=template&id=ffa45f54"
import script from "./CommonPage.vue?vue&type=script&lang=js"
export * from "./CommonPage.vue?vue&type=script&lang=js"
import style0 from "./CommonPage.vue?vue&type=style&index=0&id=ffa45f54&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports